import Proxy from '../Proxy';

class ManagerSelectProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('managersSelect', parameters);
  }
}

export default ManagerSelectProxy;
